import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ServiceUserHomePage } from './ServiceUserHomePage';
import { ProviderHomePage } from './ProviderHomePage';
import { LoadingSpinner } from '../components/LoadingSpinner';
import { ROUTES } from '../constants';

export const HomePage: React.FC = () => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50 flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (user.role === 'admin') {
    return <Navigate to={ROUTES.ADMIN_DASHBOARD} replace />;
  }

  if (user.role === 'provider') {
    return <ProviderHomePage />;
  }

  return <ServiceUserHomePage />;
};
